import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from "@material-ui/core/Paper";    

const useStyles = makeStyles(theme => ({
    paper: {
        flexShrink: '0',
        flexGrow: '1',
        textAlign: "center",
        color: '#15141A',
        marginTop: 50,
        boxShadow: "none",
    },
}));

const PageNotFound = () => {
    const classes = useStyles();

    return (
        <Paper className={classes.paper} role="main" id="main-content">
            <h1>404: Page Not Found! </h1>            
        </Paper>
    )        
};

export default PageNotFound;